import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Project from 'models/project/project.model';
import TicketCategory from 'models/ticket-category/ticket-category.model';
import { GeoCodeService } from 'services/geocode/geocode.service';
import { TicketCategoryService } from 'services/ticket-category/ticket-category.service';

@Component({
  selector: 'app-create-ticket-category',
  templateUrl: './create-ticket-category.component.html',
  styleUrls: ['./create-ticket-category.component.scss'],
})
export class CreateTicketCategoryComponent {
  public instance: TicketCategory = new TicketCategory();
  public project: Project = new Project();
  public currentVal = '';

  constructor(
    public ticketCategoryService: TicketCategoryService,
    private dialogRef: MatDialogRef<CreateTicketCategoryComponent>,
    @Inject(MAT_DIALOG_DATA) data,
  ) {
    this.project = data.project;
    if (data.item) {
      this.instance = new TicketCategory({
        ...data.item,
        project: data.project,
      });
    }
    this.instance.project = data.project;
  }

  async save() {
    this.instance.color = "#000000";
    this.instance.icon = "icon.png";
    if (this.instance.id.length > 0) {
      await this.ticketCategoryService.update(this.instance);
    } else {
      await this.ticketCategoryService.create(this.instance);
    }
    this.ticketCategoryService.list(this.project);
    this.dialogRef.close();
  }
}
